// src/components/LeadFlow.js
import React from "react";
import "./lead-screens.css";

const StepIcon = ({ number }) => (
  <div className="step-icon">
    <span>{number}</span>
  </div>
);

export default function LeadFlow() {
  return (
    <section className="lm-section flow-section">
      <div className="container">
        <div className="flow-hero">
          <h2 className="flow-title">How MarketMind4U Gets You Paid — The 3-Step AI Flow</h2>
          <p className="muted">
            Designed for local businesses: fast setup, instant visibility, verified customer pipeline and measurable ROI.
          </p>
          <div className="flow-hero-cta">
            <button className="btn ghost">Request Demo</button>
            <button className="btn primary">Claim Guarantee</button>
          </div>
        </div>

        <div className="flow-steps">
          <article className="step-card">
            <StepIcon number="1" />
            <div className="step-body">
              <h4>AI Discovery & Audit</h4>
              <p className="muted">We crawl your GMB, website, reviews & local competition. The AI finds quick wins and high-value keywords.</p>
              <ul className="small-list">
                <li>Instant visibility score</li>
                <li>Top 5 quick fixes</li>
                <li>Local demand heatmap</li>
              </ul>
            </div>
          </article>

          <article className="step-card">
            <StepIcon number="2" />
            <div className="step-body">
              <h4>Automated Growth Engine</h4>
              <p className="muted">AI runs posts, review nudges, micro-ads, and lead qualification — all on autopilot.</p>
              <ul className="small-list">
                <li>Auto review requests</li>
                <li>Smart bidding local ads</li>
                <li>WhatsApp-ready lead routing</li>
              </ul>
            </div>
          </article>

          <article className="step-card">
            <StepIcon number="3" />
            <div className="step-body">
              <h4>Verified Leads & Conversion</h4>
              <p className="muted">Leads are phone-verified and scored. You receive only high-intent customers with suggested pitch script.</p>
              <ul className="small-list">
                <li>AI lead score</li>
                <li>Suggested message templates</li>
                <li>SLA-backed delivery</li>
              </ul>
            </div>
          </article>
        </div>

        <div className="flow-faq">
          <div className="faq-left">
            <h3>FAQs — Quick Answers</h3>
            <details open>
              <summary>What does 'guaranteed lead' mean?</summary>
              <p>It means a verified, high-intent customer contact within 72 hours. If the lead fails our verification, a refund is issued per T&C.</p>
            </details>

            <details>
              <summary>Which cities are supported?</summary>
              <p>We support all major metros and expanding tier-2 cities. If your city isn't listed, request a coverage check.</p>
            </details>

            <details>
              <summary>How do I integrate leads into my workflow?</summary>
              <p>Leads are sent via WhatsApp, SMS, email or an API webhook. You choose routing and team assignments from the dashboard.</p>
            </details>
          </div>

          <div className="faq-right">
            <div className="signup-card">
              <h4>Ready to try?</h4>
              <p className="muted">Start with a free audit + guaranteed lead. No long contracts.</p>
              <form className="signup-form" onSubmit={(e)=>{ e.preventDefault(); alert('Request received — we will call you!'); }}>
                <input name="name" placeholder="Your name" required />
                <input name="phone" placeholder="Phone / WhatsApp" required />
                <select name="category">
                  <option>Local Shop / Kirana</option>
                  <option>Salon / Spa</option>
                  <option>Contractor / Service</option>
                  <option>Restaurant</option>
                </select>
                <button className="btn primary full">Request Free Audit</button>
              </form>
            </div>
          </div>
        </div>

        <div className="flow-closer">
          <p className="muted">Trusted by 1200+ businesses — powered by AI and backed with SLA. Start now and see first results in 72 hours.</p>
        </div>
      </div>
    </section>
  );
}
